import script from "./SelfServiceMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelfServiceMenu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__